// extracted by mini-css-extract-plugin
export default {"popularSearch":"PopularSearches_popularSearch__yE03b"};